import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { IoWarningSharp } from "react-icons/io5";
import { FaRegClock } from "react-icons/fa6";
import { FaCirclePlus } from "react-icons/fa6";
import moment from "moment-timezone";
import axios from "axios";
import DeleteTriggerModal from './DeleteTriggerModal';
import CreateTriggerModal from './CreateTriggerModal';
const BE_URI = process.env.REACT_APP_BE_URI;

const TriggerModal = ({
  modalVisible,
  setModalVisible,
  triggers,
  timeZone,
  urlToSend,
  token,
  buttonColor,
  handleReadData,
  t,
  currentSecondaryThemeColor,
}) => {
  const [actualTimeZone, setActualTimeZone] = useState(timeZone);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteTrigger, setDeleteTrigger] = React.useState(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [preCreateTriggerLength, setPreCreateTriggerLength] = useState(
    triggers.length
  );

  useEffect(() => {
    if (preCreateTriggerLength !== triggers.length && isCreating) {
      setIsCreating(false);
      setPreCreateTriggerLength(triggers.length);
    }
  }, [triggers.length, isCreating, preCreateTriggerLength]);

  const handleTimeZoneChange = async (timeZone) => {
    try {
      const formData = { url: urlToSend, data: `timeZone:${timeZone}` };
      const res = await axios.post(BE_URI + "/send-data", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        console.log(t("SuccesfullySendData"));
        setActualTimeZone(timeZone);
      } else {
        console.log(`Error: ${res.data.message}`);
      }
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  return (
    <Dialog open={modalVisible} onClose={() => setModalVisible(false)}>
      <DialogTitle style={{ backgroundColor: buttonColor, color: "#FFFFFF" }}>
        {t("TriggersList")}
      </DialogTitle>
      <DialogContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
         <div style={{ textAlign: "center", marginBottom: 10 }}>
          <IconButton>
            <FaRegClock style={{ color: buttonColor, fontSize: 55 }} />
          </IconButton>
          <Typography>{t("TimeZone")}</Typography>
          <Select
            value={actualTimeZone}
            onChange={(e) => handleTimeZoneChange(e.target.value)}
            style={{ backgroundColor: buttonColor, color: "white" }}
          >
            {[...Array(15).keys()].map((val) => (
              <MenuItem key={val - 12} value={val - 12}>
                {moment().utcOffset((val - 12) * 60).format("(UTC Z) z")}
              </MenuItem>
            ))}
          </Select>
        </div> 
        {triggers.length == 0 && (
            <p>{t('NoTriggers')}</p>
        )} 
        {triggers &&
            triggers.sort((a,b) =>  new Date(a.time) < new Date(b.time)).map((trigger, i) => {
            if (trigger.status) {

                const date = new Date(parseInt(trigger.time));
                let formattedDate = !trigger.time.includes(':')
                ? moment(date)
                    .utcOffset(actualTimeZone + 1)
                    .format('DD MMM YYYY HH:mm [UTC]Z')
                : trigger.time.slice(0, trigger.time.indexOf('/'));

                const isFromPast = !trigger.time.includes(':') && new Date(parseInt(trigger.time)) < new Date();

                if (trigger.time.includes(':')) {
                const restOfString = trigger.time.slice(
                    trigger.time.indexOf('/') + 1,
                );
                if (restOfString.includes('0'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Sunday').slice(0, 3);
                if (restOfString.includes('1'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Monday').slice(0, 3);
                if (restOfString.includes('2'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Tuesday').slice(0, 3);
                if (restOfString.includes('3'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Wednesday').slice(0, 3);
                if (restOfString.includes('4'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Thursday').slice(0, 3);
                if (restOfString.includes('5'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Friday').slice(0, 3);
                if (restOfString.includes('6'))
                    formattedDate =
                    formattedDate +
                    ' /' +
                    t('Saturday').slice(0, 3);
                }

                return (
                <Button
                    onClick={() => {
                    if (deleteTrigger != trigger){
                      setDeleteModalOpen(true);
                      setDeleteTrigger(trigger);
                    }
                        
                    }}
                    style={{
                    display: 'flex',
                    maxWidth: 260,
                    flexDirection: 'row',
                    height: 40,
                    marginTop: 5,
                    alignSelf: 'center',
                    }}
                    key={i}>
                    {deleteTrigger == trigger ? (
                    <CircularProgress
                      currentMainThemeColor={buttonColor}
                      style={{}}
                    />
                    ) : (
                    <IoWarningSharp
                        name={'warning'}
                        style={{ marginTop: -20 }}
                        color={buttonColor}
                        size={25}
                        onClick={() => {
                            setDeleteModalOpen(true);
                            setDeleteTrigger(trigger);
                        }}
                    />
                    )}
                    <p
                    style={{
                        color: trigger.status == 'on' ? 'green' : 'red',
                        fontWeight: 'bold',
                        marginRight: 7,
                        marginLeft: 7,
                    }}>
                    {trigger.status.toUpperCase()}
                    </p>
                    {isFromPast && <p
                    style={{
                        fontWeight: 'bold',
                        color: 'red',
                        marginRight: 7,
                        marginLeft: 7,
                    }}>
                    {"("+t("Past")+")"}
                    </p>}
                    <p
                    style={{
                        maxWidth: 180,
                        fontWeight: 'bold',
                        marginRight: 7,
                        marginLeft: 7,
                    }}>
                    {formattedDate}
                    </p>
                </Button>
                );
            }
            })}
        {isCreating ? (
              <CircularProgress
                style={{alignSelf: 'center'}}
                color={buttonColor}
                size={30}
              />
            ) : (
              triggers.length < 10? <FaCirclePlus
                color={buttonColor}
                onClick={() => {
                  setCreateModalOpen(true);
                }}
                size={30}
                style={{alignSelf: 'center', cursor: 'pointer'}}
              /> : <div></div>
            )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalVisible(false)} style={{ backgroundColor: buttonColor, color: "#FFFFFF" }}>
          {t("Cancel")}
        </Button>
        <Button onClick={() => setModalVisible(false)} style={{ backgroundColor: buttonColor, color: "#FFFFFF" }}>
          {t("Ok")}
        </Button>
      </DialogActions>
      <DeleteTriggerModal
            token={token}
            buttonColor={buttonColor}
            triggers={triggers}
            triggerToDelete={deleteTrigger}
            handleReadData={handleReadData}
            closeParentModale={()=> {
              setModalVisible(false);
            }}
            urlToSend={urlToSend}
            modalVisible={deleteModalOpen}
            currentSecondaryThemeColor={currentSecondaryThemeColor}
            setModalVisible={(open) => {
              setDeleteModalOpen(open);
            }}
            t={t}
          />
      <CreateTriggerModal
            token={token}
            buttonColor={buttonColor}
            timeZone={actualTimeZone}
            triggers={triggers}
            handleReadData={handleReadData}
            urlToSend={urlToSend}
            modalVisible={createModalOpen}
            currentSecondaryThemeColor={currentSecondaryThemeColor}
            closeParentModale={()=> {
              setCreateModalOpen(false);
            }}
            setModalVisible={() => {
              setCreateModalOpen();
            }}
            setIsCreating={() => {
              setIsCreating(true);
            }}
            t={t}
          />
    </Dialog>
  );
};

export default TriggerModal;